module.exports = __webpack_public_path__ + "img/zhaoshang.c1a1028c.png";